import { render } from "./invoice_nav.vue?vue&type=template&id=5726e781&scoped=true"
const script = {}

import "./invoice_nav.vue?vue&type=style&index=0&id=5726e781&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5726e781"]])

export default __exports__